// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"vendors-node_modules_nextiva_global-header__simple-header_dist_index_js-node_modules_nextiva_-03eced":"c2a51f63","node_modules_babel-loader_lib_index_js_ruleSet_1_rules_1_use_src_bootstrap_js":"51db888c"}[chunkId] + ".css";
};